// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics, setAnalyticsCollectionEnabled } from "firebase/analytics";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAFSMTv7U-tgqY-Vh7ZxtDqNzHxdtLljGA",
  authDomain: "tydl-d150b.firebaseapp.com",
  projectId: "tydl-d150b",
  storageBucket: "tydl-d150b.firebasestorage.app",
  messagingSenderId: "1023964608409",
  appId: "1:1023964608409:web:beeedf7a562e5064674508",
  measurementId: "G-BZSQ7CWLP5"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// 初始化Analytics并配置
const analytics = getAnalytics(app);
try {
  // 设置分析收集选项，可以在生产环境中启用
  // 在开发环境中禁用以避免CSP问题
  const isProduction = process.env.NODE_ENV === 'production';
  setAnalyticsCollectionEnabled(analytics, isProduction);
} catch (error) {
  console.warn('Analytics初始化错误:', error);
}

export { app, analytics }; 